<style>    
    .shopify-collection-products{

    }
</style>

<script>
    var debounce = require('lodash.debounce');

    import shopifyProductCard from "../shopify/shopifyProductCard";

    export default {
        props: ['collection'],
        components: {
            shopifyProductCard
        },
        mixins: [],
        data: function () {
            return {
                search: '',
                loading: false,
                products: [],
                load_more: true,
                pagination: {
                    page: 1,
                    per_page: 15
                },
                using_fallback_products: false
            }
        },
        computed: {
            id: function(){
                return 'shopCollection' + this.collection.id;
            },
        },
        watch: {
            collection: function(val, oldval){
                if(val && oldval && val.id !== oldval.id){
                    this.pagination.page = 1;
                    this.getCollectionProducts();
                }
            }
        },
        created: function () {

        },
        mounted: function () {
            this.initIntersection(document.getElementById(this.id), this.getCollectionProducts);
        },
        methods: {
            getCollectionProducts: function (cb) {
                var self = this;
                if (this.loading) {
                    return;
                }
                self.loading = true;
                var url = '/api/v5/shopify/collection/' + this.collection.id + '/products';
                var params = {
                    format: 'shopify',
                    search: this.search,
                    page: this.pagination.page,
                    per_page: this.pagination.per_page,
                    use_fallback_products: true
                };

                axios.get(url, {params: params}).then(function (response) {
                    var data = response.data.data;
                    
                    if (params.page === 1) {
                        self.load_more = true;
                        self.products = data;
                    } else {
                        self.products = self.products.concat(data);
                    }
                    
                    if(!data.length || data.length < params.per_page) {
                        self.load_more = false;
                    }
                    if(response.data.pagination && params.page === response.data.pagination.last_page){
                        self.load_more = false;
                    }
                    
                    self.using_fallback_products = response.data.using_fallback_products;
                    self.loading = false;
                    
                    if(typeof cb === 'function'){
                        cb();
                    }
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading = false;
                });
            },
            searchProducts: debounce(function(){
                var self = this;
                this.pagination.page = 1;
                this.getCollectionProducts(function(){
                    Vue.nextTick(function(){
                        self.scrollTo('#' + self.id);
                    });
                });
            }, 500),
            loadMore: function(){
                if(this.loading || !this.load_more){
                    return;
                }
                this.pagination.page++;
                this.getCollectionProducts();
            }
        }
    };

</script>

<template>
    <div :id="'shopCollection' + collection.id" v-cloak>
        <a :href="collection.shopify_url">
            <img class="w-100" :src="collection.image_url" v-if="collection.image_url" style="max-height: 200px; object-fit:cover; border-radius:5px">
        </a>
        <div class="text-center my-2">
            <a class="style-section-title text-reset hover-primary" :href="collection.shopify_url">{{collection.title}}</a>
            <div v-if="collection.description">{{collection.description}}</div>
            <div v-html="collection.body_html" v-else-if="collection.body_html"></div>
        </div>
        <div class="my-3">
            <div class="form-group">
                <div class="input-overlay-left">
                    <div class="overlay-content">
                        <i class="fas fa-spin fa-spinner" v-if="loading"></i>
                        <i class="fas fa-search" v-else></i>
                    </div>
                    <input type="text" class="form-control rounded-pill" placeholder="Search Products" v-model="search" @input="searchProducts">
                </div>
            </div>
        </div>
        <div role="alert" class="alert alert-warning alert-dismissible fade show" v-if="using_fallback_products && products.length">
            <strong>No products found in the {{collection.title}} collection.</strong> 
            <span> Displaying other store products instead.</span> 
            <button type="button" data-dismiss="alert" aria-label="Close" class="close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="row row-sm">
            <div class="col-12 col-md-3 col-lg-2" v-for="product in products" :key="product.id">
                <shopify-product-card :product="product"></shopify-product-card>
            </div>
        </div>
        <div class="text-center" v-if="products.length && load_more">
            <button class="btn btn-primary rounded-pill" :disabled="loading" @click="loadMore">
                <i class="fas fa-spin fa-spinner" v-show="loading"></i>
                Load More
            </button>
        </div>
        <div class="text-center py-3" v-if="!products.length && !loading">
            <span>No products found</span>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/shopify/shopifyCollectionProducts.vue